<template>
    <div class="image-link-component">
      <a :href="url" rel="noopener">
        <img :src="image" :alt="caption" class="image-link-thumbnail" />
        <p class="image-link-caption">{{ caption }}</p>
      </a>
    </div>
  </template>
  
  <script>
  export default {
    props: {
    url: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
  }
}
  </script>
  
  <style scoped>
  .image-link-component {
    max-width: 90%;
    margin: auto;
    text-align: center;
    box-shadow: 0 2px 11px 0 rgb(0 0 0 / 23%);
    background: linear-gradient(90deg, rgba(26,61,116,1) 0%, rgba(23,44,89,1) 100%);
    margin-bottom: 25px;
  }
  
  .image-link-thumbnail {
    max-width: 100%;
    height: auto;
  }
  
  .image-link-caption {
    padding: 10px;
    margin: 0;
    margin-top: -5px;
    color: rgba(255,255,255,1);

    font-size: 0.8em;
    font-weight: 600;
    letter-spacing: 2.5px;
    line-height: 1em;
    text-transform: uppercase;
  }

a:link { text-decoration: none; }
a:visited { text-decoration: none; }
a:hover { text-decoration: none; }
a:active { text-decoration: none; }

  </style>
  